import { gql } from '@apollo/client'

export const NotificationQuery = gql`
  query Notification($filters: NotificationFilters) {
    notifications(filters: $filters) {
      nodes {
        id
        company { id name }
        title
        message
        postedAt
        readAt
      }
    }
  }
`
